import React from 'react';
import './NavContent.css';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { getUser } from 'resources/user/selectors';
import { trackStructEvent } from '../../services/TrackingService';
import { signOut as signOutFromServer } from '../../services/AuthenticationService';
import {
  appLinks, NavLink, usPageLinks, ukPageLinks,
} from './navLinks';
import NavButton from './NavButton';
import configurationService from '../../services/ConfigurationService';

type NavContentProps = {
  onNavigate?: () => void;
};

const NavContent = ({ onNavigate }: NavContentProps) => {
  const navigate = useNavigate();
  const currentPath = window.location.pathname;
  const pageLinks = configurationService.onlyUSorLocalUStraffic() ? usPageLinks : ukPageLinks;
  const user = useSelector(getUser);

  const logout = async () => {
    await signOutFromServer();
    navigate('/sign-in');
    onNavigate?.();
  };

  const handleNavButtonClick = (link: NavLink): void => {
    trackStructEvent({
      category: 'customer_account_menu_navigation',
      label: link.label.toLowerCase(),
      action: `menu_link_clicked_${link.label.toLowerCase().replace(/ /g, '_')}`,
      property: user?.customerAccountId || 'no_customer_account_retrieved',
    });

    if (link.href === 'logout') {
      logout();

      return;
    }

    if (link.urlDestination === 'internal') {
      navigate(link.href);
      onNavigate?.();
    } else {
      window.open(link.href, '_blank');
      onNavigate?.();
    }
  };

  return (
    <div className="nav-content" data-testid="nav-content">
      {pageLinks.map(link => (
        <NavButton
          key={link.label}
          label={link.label}
          href={link.href}
          icon={link.icon}
          isActive={currentPath === link.href}
          onClick={() => handleNavButtonClick(link)}
          testId={link.label}
        />
      ))}

      <div className="divider" />

      {appLinks.map(link => (
        <NavButton
          key={link.label}
          label={link.label}
          href={link.href}
          icon={link.icon}
          isActive={currentPath === link.href}
          onClick={() => handleNavButtonClick(link)}
          testId={link.label}
        />
      ))}
    </div>
  );
};

export default NavContent;
